module.exports = __webpack_public_path__ + "img/preview-lg.6dcbc738.png";